import SearchPane from './components/SearchPane';
import './App.css';

function App() {
  return (
    <div className="App">
      <SearchPane />
    </div>
  );
}

export default App;
